<template>
  <div>
    <div class="table">
      <el-table cell-class-name='center' @row-click=handleRowClick @row-dblclick=handleRowDBClick v-loadmore="getTableData" :highlight-current-row=true :headerCellStyle="headerCellStyle" style="width: 100%" height=400 ref="table" :data="bindTableData" border tooltip-effect='dark' @selection-change="handleSelectionChange">
        <el-table-column show-overflow-tooltip v-if=isNormal(colName) :fixed=comFixed(colName) :type="colName.type" v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template v-if="colName.sub">
            <el-table-column v-for="(sub_colName,index) in colName.sub" :key="index" :property=sub_colName.property :label="sub_colName.label">
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column v-if='colName.property=="optionIcon"' :fixed=comFixed(colName) class="" :type="colName.type" v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            <div class="col-icon" v-if='scope.row.type!="file"'>
              <!-- <i class="iconfont icon-bianji" @click="showSign(scope.row)"></i>
              <i class="iconfont icon-zhexiantu" @click="handleGraph(scope.$index, scope.row,'line')"></i> -->
              <div v-show=scope.row.isSign class="sign">
                <span @click="handleGraph(scope.$index, scope.row,{type:'sphere'})">球标</span>
                <span @click="handleGraph(scope.$index, scope.row,{type:'sign'})">标记</span>
              </div>
              <i v-for="(item,index) in colName.meta" class="iconfont" :title="item.title?item.title:''" :style="{'margin-left':index==0?'0':'10px'}" :class="item.icon" @click="callEvent(scope.$index, scope.row,item)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if='colName.property=="startTime"' :fixed=comFixed(colName) class="" :type="colName.type" v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            {{ scope.row.startTime | dateFormat('yyyy-M-d hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column v-if='colName.property=="endTime"' :fixed=comFixed(colName) class="" :type="colName.type" v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            {{ scope.row.endTime | dateFormat('yyyy-M-d hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column v-if='(colName.property=="option")||colName.property=="status"' :fixed=comFixed(colName) :type="colName.type" v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            <div :class="colName.class" v-if='colName.property=="status"'>
              <!-- <span>{{scope.row.status.name}}</span> -->
              <span :class="'status-btn status-btn'+scope.row.status" @click="callEvent(scope.$index, scope.row,colName.meta)">{{statusTxt(scope.row.status,colName)}}</span>
            </div>
            <el-button v-else type="primary" :icon="icon" size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column v-if='(colName.property.indexOf("point_")>=0)' :fixed=comFixed(colName) :type="colName.type" v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            <div>
              <span class="circle" :style="computePointStyle(scope.row)"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if='colName.property=="img"' :type="colName.type" :fixed=comFixed(colName) v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            <el-image :src="scope.row.img.split('~')[0]" v-if=scope.row.img :preview-src-list="scope.row.img.split('~')" fit='contain' style="height:20px;"></el-image>
          </template>
        </el-table-column>
        <el-table-column v-if='colName.property=="arrow"' :type="colName.type" :fixed=comFixed(colName) v-for="(colName,index) in tableColName" :width='colName.width' :key=index :property=colName.property :label=colName.label>
          <template slot-scope="scope">
            <div v-if='scope.row.type!="file"'>
              <i v-for="item in colName.meta" class="iconfont" :title="item.title?item.title:''" :class="item.icon" @click="callEvent(scope.$index, scope.row,item)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" v-show="pageSizesCount != -1">
      <my-pagination :originData=tableData :pageSizesCount=pageSizesCount @getBindData=bindData></my-pagination>
    </div>
  </div>
</template>

<script>
import myPagination from './pagination'
import '../../common/css/scrollbar.css'
export default {
  name: 'costomTable',
  props: {
    tableColName: Array,
    tableData: Array,
    pageSizesCount: Number,
    activeTxt: String,
    inactiveTxt: String
  },
  data() {
    return {
      bindTableData: null,
      isSign: false
    }
  },
  components: {
    myPagination
  },
  watch: {
    bindTableData: {
      handler(newV, oldV) {
        if ((!oldV || oldV.length == 0) && newV && newV.length > 0) {
          this.$refs.table.setCurrentRow(newV[0])
        }
      },
      deep: true
    }
  },
  computed: {
    comFixed() {
      return data => {
        if (data && data.fixed) {
          return data.fixed
        }
        return false
      }
    },
    isNormal() {
      return data => {
        let colName = data.property
        return (
          colName != 'option' &&
          colName != 'status' &&
          colName != 'img' &&
          colName != 'optionIcon' &&
          colName != 'arrow' &&
          colName != 'endTime' &&
          colName != 'startTime' &&
          colName.indexOf('point_') == -1
        )
      }
    },
    statusTxt() {
      return (data, col) => {
        const str = data.status ? data.status : data
        console.log(col.meta.btntxt[str])
        return col.meta.btntxt[str]
      }
    },
    computePointStyle(val) {
      return val => {
        let style = {},
          temp = ''
        for (const key in val) {
          if (key.indexOf('point_') >= 0) {
            temp = val[key]
          }
        }
        if (temp == 1) {
          style['background-color'] = 'white'
        } else if (temp == 2) {
          style['background-color'] = '#666666'
          // style['background-color'] = 'white'
        }
        return style
      }
    },
    computeStatusStyle(val) {
      return val => {
        let style = {}
        if (val == 0) {
          style['background-color'] = 'rgb(104,241,241)'
        } else if (val == 1) {
          style['background-color'] = 'rgb(124,180,245)'
        } else if (val == 2) {
          style['background-color'] = 'rgb(40,258,24)'
        } else if (val == 3) {
          style['background-color'] = 'rgb(246,2,0)'
        }
        return style
      }
    },
    icon() {
      let val = this.tableColName[this.tableColName.length - 1].label
      let icon = 'el-icon-edit'
      if (val == '查看') {
        icon = 'el-icon-view'
      } else if (val == '详细') {
        icon = 'el-icon-info'
      }
      return icon
    }
  },
  methods: {
    callEvent(index, row, colData) {
      if (colData.type == 'inner') {
        //内部处理
        this[colData.event](index, row)
        return
      }
      this.$emit('callEvent', index, row, colData)
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      return {
        'text-align': 'center'
      }
    },
    getTableData() {
      this.$emit('callEvent', '', '', { event: 'getTableData' })
    },
    bindData(val) {
      this.bindTableData = val
    },
    proStatus(val) {
      let temp = this.tableData[0].author
      if (val == true) {
        return this.activeTxt
      } else {
        return this.inactiveTxt
      }
    },
    handleSelectionChange(row) {
      this.$emit('callEvent', '', row, { event: 'selectionChange' })
    },
    handleEdit(index, row) {
      this.$emit('callEvent', '', row, { event: 'handleEdit' })
    },
    showSign(index, data) {
      this.bindTableData.forEach(ele => {
        this.$set(ele, 'isSign', false)
      })
      this.$set(data, 'isSign', true)
    },
    handleGraph(index, row, colData) {
      row.isSign = false
      colData.event = 'handleGraph'
      this.$emit('callEvent', index, row, colData)
    },
    handleSizeChange(val) {
      this.currentPageSizes = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleRowClick(row, column, event) {
      this.$emit('callEvent', '', row, { event: 'handleRowClick' })
    },
    handleRowDBClick(row, column, event) {
      this.$emit('callEvent', '', row, { event: 'handleRowDBClick' })
    }
  },
  directives: {
    loadmore: {
      // 指令的定义
      bind(el, binding, vnode) {
        const selectWrap = el.querySelector('.el-table__body-wrapper')
        selectWrap.addEventListener('scroll', function() {
          const sign = 100
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight
          if (scrollDistance <= sign) {
            binding.value()
          }
        })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.table ::v-deep .center {
  text-align: center !important;
}
.table ::v-deep .el-table th.gutter {
  // display: table-cell !important;
  display: none !important;
}
.table ::v-deep .el-table__body {
  width: 100%;
}
.table ::v-deep .el-table--scrollable-y .el-table__body {
  width: 100% !important;
}
.table ::v-deep .el-table--scrollable-y .el-table__body-wrapper {
  overflow: overlay;
}
.table ::v-deep .el-table--fit .el-table__body {
  width: auto;
}
.table ::v-deep .el-table__body,
.table ::v-deep .el-table__footer,
.table ::v-deep .el-table__header {
  // table-layout: auto;
}
.table ::v-deep .el-table--fit .el-table__header {
  width: auto;
}
.table ::v-deep .el-table__header {
  width: 100%;
}
.table ::v-deep .el-table--border {
  border: none !important;
  border-top: 1px solid #ebeef5 !important;
}
.block {
  padding-top: 20px;
  padding-bottom: 20px;
}
.circle {
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  margin-bottom: -2px;
  float: none !important;
  border: 1px solid #666666;
}
.table ::v-deep .el-table td,
.table ::v-deep .el-table th.is-leaf {
  border-bottom: 1px solid #ebeef5;
  // border-left: 1px solid #ebeef5 !important;
}
.table ::v-deep .el-table--border td,
.table ::v-deep .el-table--border th,
.table
  ::v-deep
  .el-table__body-wrapper
  .table
  ::v-deep
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-right: none;
}
.table ::v-deep .el-table__empty-block {
  border-left: 1px solid #ebeef5 !important;
}
.table ::v-deep .el-table__header-wrapper {
  border-top: 1px solid #ebeef5 !important;
}
.table ::v-deep .el-table__header .cell {
  font-size: 14px !important;
  color: black !important;
}
.table ::v-deep .el-icon-circle-close {
  color: white;
}
.table {
  ::v-deep {
    .el-table__body-wrapper::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 7px;
      height: 7px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 100px;
      box-shadow: inset 0 0 3px white;
      background: #aaa;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 3px white;
      border-radius: 5px;
      background: white;
    }
    .el-table__body-wrapper {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
i {
  cursor: pointer;
}
.sign {
  position: absolute;
  z-index: 99;
  left: 100px;
  box-shadow: 0 0 5px -1px;
  color: #666666;
  width: 100px;
  background-color: white;
}
.sign span {
  line-height: 0.15rem;
  display: block;
  text-align: center;
  padding: 10px 5px;
  cursor: pointer;
}
.sign span:hover {
  background-color: #f0f0f0;
  color: #0078d7;
}
</style>


// WEBPACK FOOTER //
// src/components/common/table.vue